module.exports = __webpack_public_path__ + "static/media/img_hero_ContactUs.139588ab.jpg";